import { render, staticRenderFns } from "./OrderablePreviewItemTaxes.vue?vue&type=template&id=d8ddce20&"
import script from "./OrderablePreviewItemTaxes.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewItemTaxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports